import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Eye, UserCheck, Database, Mail, Phone, MapPin } from 'lucide-react';
import { Button } from './ui/button';

const Privacidade = () => {
  const dataAtualizacao = "04 de Fevereiro de 2026";

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-[rgb(25,42,86)] text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/">
            <Button variant="ghost" className="text-white hover:bg-white/20 mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Voltar ao Início
            </Button>
          </Link>
          <div className="flex items-center space-x-4">
            <Shield className="h-12 w-12" />
            <div>
              <h1 className="text-3xl md:text-4xl font-black">Política de Privacidade</h1>
              <p className="text-white/80 mt-1">Última atualização: {dataAtualizacao}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Conteúdo */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
          
          {/* Introdução */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <Shield className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              1. Introdução
            </h2>
            <p className="text-gray-700 leading-relaxed">
              A <strong>Knorr Leilões</strong> ("nós", "nosso" ou "Empresa"), inscrita no CNPJ sob o nº 07.104.478/0001-00, 
              com sede em Pelotas/RS, está comprometida em proteger a privacidade e os dados pessoais de nossos usuários, 
              clientes e visitantes ("você" ou "usuário").
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Esta Política de Privacidade descreve como coletamos, usamos, armazenamos, compartilhamos e protegemos 
              suas informações pessoais quando você utiliza nosso site (www.knorrleiloes.com.br) e nosso aplicativo 
              móvel disponível nas lojas Google Play e App Store.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Ao utilizar nossos serviços, você concorda com as práticas descritas nesta Política de Privacidade, 
              em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
            </p>
          </section>

          {/* Dados Coletados */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <Database className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              2. Dados que Coletamos
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Coletamos diferentes tipos de informações para fornecer e melhorar nossos serviços:
            </p>
            
            <h3 className="text-lg font-semibold text-[rgb(25,42,86)] mt-6 mb-2">2.1 Dados Fornecidos por Você</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Dados de Cadastro:</strong> Nome completo, CPF/CNPJ, endereço, telefone, e-mail</li>
              <li><strong>Dados de Identificação:</strong> Documentos pessoais para validação de cadastro</li>
              <li><strong>Dados Financeiros:</strong> Informações bancárias para recebimento ou pagamento</li>
              <li><strong>Dados de Comunicação:</strong> Mensagens enviadas através de nossos canais de contato</li>
            </ul>

            <h3 className="text-lg font-semibold text-[rgb(25,42,86)] mt-6 mb-2">2.2 Dados Coletados Automaticamente</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Dados de Navegação:</strong> Endereço IP, tipo de navegador, páginas visitadas</li>
              <li><strong>Dados do Dispositivo:</strong> Modelo do dispositivo, sistema operacional, identificadores únicos</li>
              <li><strong>Dados de Localização:</strong> Localização aproximada baseada no IP (não utilizamos GPS sem consentimento)</li>
              <li><strong>Cookies e Tecnologias Similares:</strong> Para melhorar a experiência de navegação</li>
            </ul>

            <h3 className="text-lg font-semibold text-[rgb(25,42,86)] mt-6 mb-2">2.3 Dados de Terceiros</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Informações de parceiros comerciais autorizados</li>
              <li>Dados públicos disponíveis em registros oficiais</li>
            </ul>
          </section>

          {/* Uso dos Dados */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <Eye className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              3. Como Utilizamos seus Dados
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Utilizamos suas informações para as seguintes finalidades:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Prestação de Serviços:</strong> Realizar leilões, processar lances, gerenciar arrematações</li>
              <li><strong>Comunicação:</strong> Enviar notificações sobre leilões, confirmações de lances, informações importantes</li>
              <li><strong>Atendimento ao Cliente:</strong> Responder dúvidas e solicitações</li>
              <li><strong>Segurança:</strong> Prevenir fraudes e atividades ilegais</li>
              <li><strong>Cumprimento Legal:</strong> Atender obrigações legais e regulatórias</li>
              <li><strong>Melhorias:</strong> Aprimorar nossos serviços e experiência do usuário</li>
              <li><strong>Marketing:</strong> Enviar comunicações promocionais (com seu consentimento)</li>
            </ul>
          </section>

          {/* Compartilhamento */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <UserCheck className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              4. Compartilhamento de Dados
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Podemos compartilhar seus dados nas seguintes situações:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Parceiros de Negócio:</strong> Vendedores/comitentes para conclusão de transações</li>
              <li><strong>Prestadores de Serviço:</strong> Empresas que nos auxiliam na operação (hospedagem, pagamentos, etc.)</li>
              <li><strong>Autoridades:</strong> Quando exigido por lei ou ordem judicial</li>
              <li><strong>Proteção de Direitos:</strong> Para proteger nossos direitos, propriedade ou segurança</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              <strong>Não vendemos</strong> suas informações pessoais a terceiros para fins de marketing.
            </p>
          </section>

          {/* Segurança */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <Lock className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              5. Segurança dos Dados
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Implementamos medidas técnicas e organizacionais para proteger seus dados:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Criptografia de dados em trânsito (HTTPS/SSL)</li>
              <li>Criptografia de dados sensíveis armazenados</li>
              <li>Controle de acesso restrito a funcionários autorizados</li>
              <li>Monitoramento contínuo de segurança</li>
              <li>Backups regulares</li>
              <li>Firewalls e proteção contra malware</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Embora nos esforcemos para proteger suas informações, nenhum método de transmissão pela Internet 
              ou armazenamento eletrônico é 100% seguro. Recomendamos que você também tome precauções, 
              como usar senhas fortes e não compartilhar suas credenciais.
            </p>
          </section>

          {/* Direitos do Usuário */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4 flex items-center">
              <UserCheck className="h-6 w-6 mr-2 text-[rgb(238,29,37)]" />
              6. Seus Direitos (LGPD)
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem os seguintes direitos:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Confirmação e Acesso:</strong> Confirmar a existência de tratamento e acessar seus dados</li>
              <li><strong>Correção:</strong> Solicitar a correção de dados incompletos, inexatos ou desatualizados</li>
              <li><strong>Anonimização/Bloqueio/Eliminação:</strong> Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
              <li><strong>Portabilidade:</strong> Solicitar a portabilidade dos dados a outro fornecedor</li>
              <li><strong>Eliminação:</strong> Solicitar a eliminação dos dados tratados com seu consentimento</li>
              <li><strong>Informação:</strong> Ser informado sobre compartilhamento de dados</li>
              <li><strong>Revogação:</strong> Revogar o consentimento a qualquer momento</li>
              <li><strong>Oposição:</strong> Opor-se ao tratamento em caso de descumprimento da LGPD</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Para exercer seus direitos, entre em contato conosco através dos canais indicados na seção "Contato".
            </p>
          </section>

          {/* Retenção de Dados */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4">
              7. Retenção de Dados
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Mantemos seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades para as quais 
              foram coletados, incluindo obrigações legais, contratuais, de prestação de contas ou requisição de 
              autoridades competentes.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              Após o término do tratamento, os dados serão eliminados, salvo nas hipóteses previstas em lei, 
              como cumprimento de obrigação legal ou regulatória.
            </p>
          </section>

          {/* Cookies */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4">
              8. Cookies e Tecnologias Similares
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Utilizamos cookies e tecnologias similares para:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li><strong>Cookies Essenciais:</strong> Necessários para o funcionamento do site</li>
              <li><strong>Cookies de Desempenho:</strong> Coletam informações sobre como você usa o site</li>
              <li><strong>Cookies de Funcionalidade:</strong> Lembram suas preferências</li>
              <li><strong>Cookies de Marketing:</strong> Utilizados para exibir anúncios relevantes</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Você pode gerenciar as preferências de cookies através das configurações do seu navegador. 
              Note que desabilitar alguns cookies pode afetar a funcionalidade do site.
            </p>
          </section>

          {/* Menores de Idade */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4">
              9. Menores de Idade
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nossos serviços não são direcionados a menores de 18 anos. Não coletamos intencionalmente 
              dados pessoais de menores. Se você é pai ou responsável e acredita que seu filho nos forneceu 
              informações pessoais, entre em contato conosco para que possamos tomar as medidas necessárias.
            </p>
          </section>

          {/* Alterações */}
          <section>
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4">
              10. Alterações nesta Política
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Podemos atualizar esta Política de Privacidade periodicamente. Quando fizermos alterações 
              significativas, notificaremos você através do site, aplicativo ou e-mail. Recomendamos que 
              você revise esta política regularmente para estar informado sobre como protegemos suas informações.
            </p>
            <p className="text-gray-700 leading-relaxed mt-4">
              A data da última atualização está indicada no início deste documento.
            </p>
          </section>

          {/* Contato */}
          <section className="bg-gray-50 rounded-xl p-6">
            <h2 className="text-2xl font-bold text-[rgb(25,42,86)] mb-4">
              11. Contato
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Se você tiver dúvidas sobre esta Política de Privacidade ou sobre o tratamento de seus dados 
              pessoais, entre em contato conosco:
            </p>
            
            <div className="space-y-3">
              <p className="flex items-center text-gray-700">
                <strong className="mr-2">Knorr Leilões</strong>
              </p>
              <p className="flex items-center text-gray-700">
                <Mail className="h-5 w-5 mr-3 text-[rgb(238,29,37)]" />
                <a href="mailto:contato@knorrleiloes.com.br" className="text-[rgb(25,42,86)] hover:underline">
                  contato@knorrleiloes.com.br
                </a>
              </p>
              <p className="flex items-center text-gray-700">
                <Phone className="h-5 w-5 mr-3 text-[rgb(238,29,37)]" />
                <a href="tel:+555381146431" className="text-[rgb(25,42,86)] hover:underline">
                  (53) 98114-6431
                </a>
              </p>
              <p className="flex items-center text-gray-700">
                <MapPin className="h-5 w-5 mr-3 text-[rgb(238,29,37)]" />
                Pelotas - RS, Brasil
              </p>
            </div>

            <p className="text-gray-700 leading-relaxed mt-6">
              <strong>Encarregado de Proteção de Dados (DPO):</strong><br />
              Para questões específicas relacionadas à LGPD, entre em contato através do e-mail: 
              <a href="mailto:contato@knorrleiloes.com.br" className="text-[rgb(25,42,86)] hover:underline ml-1">
                contato@knorrleiloes.com.br
              </a>
            </p>
          </section>

          {/* Rodapé */}
          <div className="text-center pt-8 border-t">
            <p className="text-gray-500 text-sm">
              © {new Date().getFullYear()} Knorr Leilões. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-sm mt-2">
              Esta Política de Privacidade está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Privacidade;
